import { PCImage } from 'app/design/primitives/image';
import { ChannelRow } from './channel';

import { type GroupChannel as GroupChannelType } from 'app/types/chat';
import { GroupAvatarStack } from '../../components/group-avatar-stack';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const GroupChannel = function GroupChannel(channel: GroupChannelType) {
  const prefix = !channel.picture ? (
    <GroupAvatarStack members={channel.members} size={60} />
  ) : (
    <PCImage
      aspectRatio={1}
      height={60}
      source={{ uri: channel.picture }}
      style={{
        borderRadius: theme.borderRadii['radius.full'],
      }}
    />
  );
  return <ChannelRow channel={channel} prefix={prefix} />;
};

export { GroupChannel };
